module.exports = __webpack_public_path__ + "img/referral-image.8544c468.png";